module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp23_1.87fa195f.png";